import React from 'react';
import { useTheme } from '@vw-marketing/us-components';
import { AvatarContainer } from './styles';

interface ProfileAvatarProps {
  name: string;
  size?: number;
  backgroundColor?: string;
  color?: string;
  fontSize?: number;
  className?: string;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  name,
  backgroundColor,
  color,
  className,
}) => {
  const theme = useTheme();
  const resolvedBackgroundColor = backgroundColor ?? theme.colors.content.active;
  const resolvedColor = color ?? theme.colors.content.inverted;
  const letter = name ? name.charAt(0).toUpperCase() : '';

  return (
    <AvatarContainer
      backgroundColor={resolvedBackgroundColor}
      color={resolvedColor}
      className={className}
    >
      {letter}
    </AvatarContainer>
  );
};

export default ProfileAvatar;
